module.exports = __webpack_public_path__ + "static/1337224522.1ebe2498.jpg";